import { InputFollowupFileToUpload } from './input-followup-file-to-upload';

export class InputAdministrativeQuery {
    subject: string;
    followup_text: string;
    category_uniquekey: string;
    input_filename_to_upload?: InputFollowupFileToUpload;
}